import {
  SequenceMenu,
  usePersistMagicTableQueryParams
} from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'
import { usageMetricsPaths } from 'modules/UsageMetrics/usageMetrics.router'
import { usePermissions } from 'lib/rbac'

export const EditUsageMetric = (props: {
  usageMetricId: string
  isACustomMetric: boolean
}) => {
  const navigate = useNavigate()
  const { persistMagicTableQueryParams } = usePersistMagicTableQueryParams()
  const { can } = usePermissions()

  if (!can('org.usage:update') || props.isACustomMetric) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="usageMetrics.editUsageMetric.menuItem"
      uuid="edit-usage-metric"
      label="Edit usage metric"
      onClick={() => {
        navigate(
          persistMagicTableQueryParams(
            usageMetricsPaths.edit(props.usageMetricId)
          )
        )
      }}
    />
  )
}
